import { takeEvery, put, call } from "redux-saga/effects";
import {
  getSettingsDetailsAction,
  updateSettingsDetailsAction,
} from "../api/settings";
import { getSettingsDetail } from "../redux/app/setttings/setting-slice";

export function* getSettingsSaga() {
  try {
    const response = yield call(getSettingsDetailsAction);

    yield put(
      getSettingsDetail({
        settings: response.data[0],
      })
    );
  } catch (error) {}
}

export function* updateSettingsSaga(action) {
  try {
    const response = yield call(updateSettingsDetailsAction, action.payload);

    yield put(
      getSettingsDetail({
        settings: response.data,
      })
    );
  } catch (error) {}
}

export function* watchSettingsAsync() {
  yield takeEvery("GET_SETTINGS", getSettingsSaga);
  yield takeEvery("UPDATE_SETTINGS", updateSettingsSaga);
}
